import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface IMenuType {
  open: boolean;
  items: Record<
    string,
    {
      id: string,
      name: string,
      link: string,
      active: boolean,
    }>
}

const initialState: IMenuType = {
  open: false,
  items: {
    main: {
      id: 'main',
      name: 'Главная',
      link: '/',
      active: false
    },
    map: {
      id: 'commercial',
      name: 'Каталог объектов',
      link: '/map',
      active: false
    }
  }


}

export const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    openMobileSidebar(state) {
      state.open = true
    },
    closeMobileSidebar(state) {
      state.open = false
    },
    setMenuItemActive(state, action: PayloadAction<{ url: string}>) {

      const { url} = action.payload;
      for (const key in state.items) {
        if (state.items.hasOwnProperty(key)) {
          state.items[key].active = false;
        }
      }
      if (url === '/') {
        state.items.main.active = true;
      } else if (url === '/map') {
        state.items.map.active = true;
      }
    },
  },
})

export const { openMobileSidebar, closeMobileSidebar, setMenuItemActive } = menuSlice.actions;

export default menuSlice.reducer